import storefront from './storefront.js'
import queryProductsByHandle from './queryProductsByHandle.js'

const MsrpProductData = class {
  constructor () {
    this.storageHandle = 'product-msrp-prices'

    try {
      const localProductData = window.sessionStorage.getItem(this.storageHandle)
      this.productData = JSON.parse(localProductData)
      if (!localProductData) { throw Error('no product price data, moving on') }
    } catch (error) {
      this.productData = {}
      console.log(error)
    }
  }

  async getMsrpProductData (handle) {
    if (this.productData[handle]) {
      return this.productData[handle]
    }

    const msrpProductJson = await storefront.fetch(queryProductsByHandle(handle))
    const wholesaleProductJson = await this.fetchProductData(handle, 'same-origin')

    const productPriceData = {}

    if (msrpProductJson.product?.variants?.edges) {
      productPriceData.msrp = {
        price: Math.round(Number(msrpProductJson.product.price.minVariantPrice.amount) * 100, 2),
        variants: msrpProductJson.product.variants.edges.map(({ node: { id, price } }) => ({
          id: Number(id.replace(/[^0-9]+/g, '')),
          price: Math.round(Number(price.amount) * 100)
        }))
      }
    }

    if (wholesaleProductJson?.variants) {
      productPriceData.wholesale = {
        price: wholesaleProductJson.price,
        variants: wholesaleProductJson.variants.map(({ id, price }) => ({ id, price }))
      }
    }

    this.productData[handle] = productPriceData

    window.sessionStorage.setItem(this.storageHandle, JSON.stringify(this.productData))

    return productPriceData
  }

  async fetchProductData (handle, credentials) {
    const productJson = await fetch(`/products/${handle}.js`, {
      credentials,
      method: 'GET',
      headers: {
        'X-Requested-With': 'xmlhttprequest'
      }
    }).then(result => {
      return result.json()
    }).catch(error => {
      console.error(error)
      return false
    })

    return productJson
  }
}

window.msrpClass = new MsrpProductData()